import React from "react";
import AuthRoutes from "./Routes/authRoutes";
import AdminRoutes from "./Routes/adminRoutes";
import PermissionRoutes from "./Routes/permissionRoutes";
import CategoriesRoutes from "./Routes/categoriesRoutes";
import CountryRoutes from "./Routes/countryRoutes";
import StateRoutes from "./Routes/stateRoutes";
import AgentRoutes from "./Routes/agentRoutes";
import HomeVisitRoutes from "./Routes/homeVisitRoutes";
import AgentProfitRangesRoutes from "./Routes/agentProfitRangeRoute";
import AccessListRoutes from "./Routes/accessListRoute";
import CityRoutes from "./Routes/cityRoutes";
import CollectionRoutes from "./Routes/collectionsRoutes";
import UnitsRoutes from "./Routes/unitsRoutes";
import AmenitiesRoutes from "./Routes/amenitiesRoutes";
import BuilderRoutes from "./Routes/builderRoutes";
import KioskRoutes from "./Routes/kiosk.Routes";
import ManageProjectsRoutes from "./Routes/manageProjectsRoutes";
import TeamRoutes from "./Routes/teamRoutes";
import PropertiesRoutes from "./Routes/propertiesRoutes";
import CouponsRoutes from "./Routes/couponsRoutes";
import MeetingRoutes from "./Routes/meetingRoutes";
import EventRoutes from "./Routes/eventsRoutes";
import SettingsRoutes from "./Routes/settingsRoutes";
import ListUsers from "./Routes/usersRoutes";
import EmailAddRoutes from "./Routes/emailAddRoutes";
import BookingRoutes from "./Routes/bookingsRoutes";
import PaymentRoutes from "./Routes/paymentsRoutes";
import ConfigRoutes from "./Routes/configRoutes";
import BannerAdsRoutes from "./Routes/banner_adsRoutes";
import ChatRoutes from "./Routes/chatRoutes";
import DealsRoutes from "./Routes/dealsRoutes";
import WalletRefundRoutes from "./Routes/walletRefundRoutes";
import NewsRoutes from "./Routes/newsRoutes";
import NewsBrandRoutes from "./Routes/newsBrandRoutes";
import BrandsRoutes from "./Routes/brandsRoutes";
import SurroundingRoutes from "./Routes/surrounding-indutries";
import DashBoardRoutes from "./Routes/dashboardRoutes";
import LeadRoutes from "./Routes/leadRoutes";
import LogsRoutes from "./Routes/logsRoutes";
import InvitesRoutes from "./Routes/invitesRoutes";
import EnquiryRoutes from "./Routes/enquiryRoutes";
import CabSettingRoutes from "./Routes/cabSettingRoutes";
import ConsultantRoutes from "./Routes/consultantRoutes";
import CancellationPoliciesRoutes from "./Routes/cancellationRoutes";
import CurrencyRoutes from "./Routes/currencyRoutes";
import PlanRoutes from "./Routes/planRoutes";
import NotificationRoutes from "./Routes/notificationRoutes";
import EmailRoutes from "./Routes/emailTemplatesRoutes";
import ChangePasswordRoutes from "./Routes/ChangePasswordRoutes";
import FaqRoutes from "./Routes/FaqRoutes";
import DealsAndOfferRoutes from "./Routes/DealsAndOffersRoutes";
import CabServiceProviderRoutes from "./Routes/CabServiceProviderRoutes";
import SiteVisitRoutes from "./Routes/siteVisitRoutes";
import ReferralsRoutes from "./Routes/referralsRoutes"
import RewardsRoutes from "./Routes/rewardsRoutes"
import LocalityRoutes from "./Routes/localityRoutes"
import ReferralCommissionRoutes from "./Routes/referralCommissionRoutes"
import FranchiseRoutes from "./Routes/franchiseRoutes"
import RankingRoutes from "./Routes/rankingRoutes"
import OoraPlanRoutes from "./Routes/ooraRoute"
import FinancePartnersRoutes from "./Routes/financePartnersRoutes"
import RatingReviewPanelSection from "./Routes/ratingReviewPanelRoutes"
import ComingSoonCitiesRoutes from "./Routes/comingSoonCitiesRoute"
import AppointmentConfigRoutes from "./Routes/appointmentConfigRoute"

const Router = () => {
  return (
    <div>
      <AuthRoutes />
      <ChatRoutes />
      <MeetingRoutes />
      <BookingRoutes />
      <KioskRoutes/>
      <AdminRoutes />
      <PermissionRoutes />
      <CategoriesRoutes />
      <LeadRoutes></LeadRoutes>
      <CountryRoutes />
      <LogsRoutes></LogsRoutes>
      <StateRoutes />
      <AgentRoutes />
      <RatingReviewPanelSection />
      <HomeVisitRoutes />
      <AgentProfitRangesRoutes />
      <CityRoutes />
      <AccessListRoutes ></AccessListRoutes>
      <CurrencyRoutes />
      <CollectionRoutes />
      <UnitsRoutes />
      <RankingRoutes />
      <ComingSoonCitiesRoutes />
      <AmenitiesRoutes />
      <OoraPlanRoutes />
      <AppointmentConfigRoutes />
      <BuilderRoutes />
      <ManageProjectsRoutes />
      <TeamRoutes />
      <PropertiesRoutes />
      <CouponsRoutes />
      <EventRoutes />
      <SettingsRoutes />
      <ListUsers />
      <LocalityRoutes />
      <PaymentRoutes />
      <ConfigRoutes />
      <EmailAddRoutes></EmailAddRoutes>
      <BannerAdsRoutes />
      <DealsRoutes />
      <PlanRoutes />
      <SiteVisitRoutes />
      <ConsultantRoutes />
      <WalletRefundRoutes />
      <NewsRoutes></NewsRoutes>
      <NewsBrandRoutes></NewsBrandRoutes>
      <BrandsRoutes></BrandsRoutes>
      <SurroundingRoutes></SurroundingRoutes> 
      <DashBoardRoutes></DashBoardRoutes>
      <InvitesRoutes></InvitesRoutes>
      <EnquiryRoutes></EnquiryRoutes>
      <CabSettingRoutes></CabSettingRoutes>
      <NotificationRoutes></NotificationRoutes>
      <EmailRoutes></EmailRoutes>
      <CancellationPoliciesRoutes></CancellationPoliciesRoutes>
      <ChangePasswordRoutes></ChangePasswordRoutes>
      <FaqRoutes></FaqRoutes>
      <DealsAndOfferRoutes></DealsAndOfferRoutes>
      <ReferralsRoutes></ReferralsRoutes>
      <RewardsRoutes></RewardsRoutes>
      <ReferralCommissionRoutes></ReferralCommissionRoutes>
      <FranchiseRoutes></FranchiseRoutes>
      <FinancePartnersRoutes></FinancePartnersRoutes>
      <CabServiceProviderRoutes />
    </div>
  );
};

export default Router;
